import React from 'react';
import '../home/home.css';
import PremiumHeader from '../navbar/PremiumHeader';
import OptionBar from './optionBar/OptionBar';
import SEO from '../seo/SEO';

const Home = () => {
  return (
    <>

      <SEO
        title="Home"
        description="Discover the best hotels, guest houses, and properties for your perfect stay. Book accommodations with ease on SPOTFLI."
        keywords="hotel booking, accommodation, guest house, property rental, vacation rental, travel"
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'SPOTFLI',
          url: 'https://www.spotfli.com',
          logo: 'https://www.spotfli.com/og-image.jpg',
          description: 'Discover the best hotels, guest houses, and properties for your perfect stay on SPOTFLI.',
          sameAs: [
            'https://www.facebook.com/profile.php?id=61586130602801',
            'https://www.instagram.com/spotfliteam/'
          ],
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer service',
            availableLanguage: 'English'
          }
        }}
      />
      <PremiumHeader />
      {/* <OptionBar /> */}
      <div className="home-container">
        <div className="home-option-bar">
          <OptionBar />
        </div>
      </div>
    </>
  );
};

export default Home;
